import React,{ useState,useEffect } from 'react';
import styled from 'styled-components';
import { useMutation, useQuery } from '@apollo/client';
import { useForm } from 'react-hook-form';
import { useRouteMatch } from 'react-router-dom'


import {textAreaStyle} from '../styles/includes/forms'

// Components
import StyledPageMargin from '../components/StyledPage';
import Field from '../components/InputField';
import Button from '../components/Button';
import Label from '../components/InputLabel';
import OptionList from '../components/InputOptionList';
import FormErrors, { trowError } from '../components/FormErrors';
import InputFileUpload from '../components/InputFileUpload';
import InputImageCrop from '../components/InputImageCrop';
import Loading from '../components/Loading';


// Assets
import samplePhoto from '../assets/images/samples/foto3.png';
import pdfPrivacidad from '../assets/pdfs/Aviso_de_Privacidad_para_credencial_y_Asistencia_Animación_29_03.pdf';



import { VALIDATE_ACREDITACION, GET_INFO_PROFILE_BY_EMAIL, listGenero } from '../models/AcreditacionProfile';


const StyledPage = styled(StyledPageMargin)`
  .photo-input-file-wrapper {
    margin-top: 2rem
  }
`

const StyledForm = styled.form`
  h1 {
    margin-bottom: 2.5rem;
  }
  h2 {
    margin: 1.5rem 0;
  }
  h3 {
    margin: 1.3rem 0;
  }
  textarea {
    ${textAreaStyle}
    width: 100%;
    height: 80px;
    padding: 12px;
  }
  .field {
    margin-bottom: 1rem;
  }
  .page-footer {
    text-align: center;
    margin-top: 2rem
  }
  .sample-photo {
    max-width: 120px;
    margin: auto;
    img {
      box-shadow: var(--base-box-shadow);
      width: 100%;
    }
  }
`

const CheckStyled=styled.label`
    display: flex;
    padding:6px;
    margin:auto;
    cursor: pointer;
    .check{
        padding-right: 10px;
    }
`;

const Contenedor=styled.label`
    max-width:800px;
    width:100%;
    margin: 0 auto;
    display: flex;
    cursor: pointer;
    .check{
        padding-right: 10px;
    }
`;

interface MatchParams{
  uuid:string
  token:string
}

export default  () => {
    const { params } = useRouteMatch<MatchParams>();

    const [ validateAcreditationForm, { loading }] = useMutation(VALIDATE_ACREDITACION);
    const { register, handleSubmit, getValues, errors, setValue } = useForm({
        defaultValues:(process.env.NODE_ENV==='development')?{
            name:'test',
            last_name:'test lastname',
            second_last_name:'Second test lastname',
            tel_cell:'0000000000',
            birth_date:'2020-12-20',
            gender:'masculino',

            curp:'0123456789012345678',

            password:'123456',
            repeat_password:'123456',       
        }:{}
    });

    const [submitError,setSubmitError] = useState<null|string>(null);

    const onSubmit = async (data:any) => {
        console.log('on Send data:',data);
        try{
            setSubmitError(null);

            let {repeat_password,aviso,terminos, code,  ...dataChange}=data;
            let response=await validateAcreditationForm({ 
                variables:{
                    input:{
                        ...dataChange
                    },
                    profile_uuid:params.uuid,
                    code
                },
                context:{
                    clientName: 'LOGIN',
                }                
            });
            if(response.errors)
                throw new trowError(response.errors);


            location.href='/';
        }catch(e){
            console.error(e);
            setSubmitError(e);
            window.scrollTo(0,0);
        }
    }

    return (
        <StyledPage>
            <Contenedor>

            
                <StyledForm onSubmit={handleSubmit(onSubmit)}>
                    <h1 style={{textAlign:'center'}}>Favor de llenar el formulario con los siguientes datos.</h1>
                   

                    <p>Hemos enviado a tu correo electrónico un código de un solo uso. Para continuar tu proceso de registro, debes introducir el 
                        código que recibiste por correo y posteriormente completar el siguiente formulario con todos tus datos. 
                        Si tienes alguna duda durante el proceso, puedes contactarnos vía correo a <a href='mailto:abonados@atleticodesanluis.mx'>abonados@atleticodesanluis.mx</a> 
                        o al Whatsapp <a href="https://wa.me/524441118872?text=%C2%A1Hola%20ADSL!%20" target='_blank'>444 111 8872</a>.</p>
                    
                    <hr/>
                    {submitError?<div className="error-message"><FormErrors errors={submitError} /></div>:null}

                    <section>           
                        <Field label='Código del correo' name='code' ref={register} required  ></Field>
                    </section>

                    <section>           
                        <h2>Datos personales</h2>
                        <Field label='Nombre(s)' name='name' ref={register} required  ></Field>
                        <Field label='Apellido paterno' name='last_name' ref={register} required ></Field>
                        <Field label='Apellido materno' name='second_last_name' ref={register}  required ></Field>
                        <Field label='Fecha de nacimiento' name='birth_date' type='date' ref={register}  required ></Field>
                        <Field label='Teléfono celular' name='tel_cell' ref={register} required  type="number" max={9999999999}></Field>
                        <div className="field">
                            <Label>Género</Label>
                            <OptionList name='gender' options={listGenero} ref={register} required />
                        </div>
                        <hr/>
                    </section>
                    <section>
                        <h2>Fotografía</h2>
                        <div className="base-content">
                            <p>Para vincular tu foto con tu perfil de Abonado ADSL, es importante que la foto tenga las siguientes características:</p>
                            <ol>
                                <li>Con fondo blanco o claro y buena iluminación</li>
                                <li>Sin lentes y sin gorra</li>
                                <li>Mirando de frente a la cámara</li>
                                <li>El encuadre de la foto debe ser vertical, del pecho hacia arriba, como en este ejemplo:</li>
                            </ol>
                            <div className="sample-photo">
                                <img src={samplePhoto} alt="Foto de ejemplo"/>
                            </div>
                            <p>Una vez que la foto haya sido encuadrada en el espacio correspondiente, da click en el botón de "Guardar foto".</p>
                        </div>
                        <div className="photo-input-file-wrapper text-center">
                            <InputImageCrop name="avatar_key" ref={register} config={{width: 250, height: 300, output: {width: 800, height: 960}}} />
                        </div>
                    </section>
                    <hr />                
                    <section>
                        <hr/>
                        <Field label='Contraseña' name='password' type='password' ref={register} required></Field>
                        <Field label='Repetir contraseña' name='repeat_password' type='password' ref={register} required></Field>
                    </section>
                    <section>
                        <CheckStyled>
                            <div className="check"><input type="checkbox" name="aviso"  ref={register}  required/></div>
                            <div className="text"><a href="https://www.atleticodesanluis.mx/contenidos/aviso-de-privacidad" target="_blank">Acepto el Aviso de Privacidad</a></div>
                        </CheckStyled>                
                    </section>

                    <section>
                        <h2 style={{color:' #4d4d4d',fontSize:'35px'}}>IMPORTANTE</h2>
                        <p style={{textAlign:'center'}}>
                        Una vez que hayas cargado tu foto y completado tus datos, da click en el botón de CREAR CUENTA para que posteriormente puedas loguearte con tu cuenta de correo y el password que elegiste.
                        </p>
                    </section>


                    <div className="page-footer">
                        <Button type='submit' disabled={loading}>Crear cuenta</Button>
                    </div>
                </StyledForm>
            </Contenedor>
        </StyledPage>
    )
}
